import { ReactComponent as ChevronRightIcon } from '../../../../assets/images/icons/right-arrow.svg';
import { ReactComponent as Alert } from '../../../../assets/images/icons/alert-pure.svg';
import { Box } from '../../../../components/UI-CHAKRA/Box';
import { Button } from '../../../../components/UI-CHAKRA/Button';
import { Flex } from '../../../../components/UI-CHAKRA/Flex';
import { Text } from '../../../../components/UI-CHAKRA/Text';
import { FONT_ONEST, SNCR_COLORS } from '../constants';
import { useSncrRequestShortcut } from '../useSncrRequestShortcut';
import { SncrAuthRequiredModal } from './SncrAuthRequiredModal';
import { SncrErrorModal } from './SncrErrorModal';
import { SncrFeedbackModal } from './SncrFeedbackModal';

/**
 * Card de aviso exibido acima da lista de medicamentos quando a prescrição não
 * tem saldo de numeração SNCR para o tipo de receita em questão.
 *
 * O botão "Solicitar numeração" dispara o atalho de solicitação (apenas os
 * tipos de receita sem numeração reservada nesta prescrição, cada um na
 * quantidade padrão) via {@link useSncrRequestShortcut} e orquestra os três modais do
 * fluxo: autenticação obrigatória, processamento/resultado e erro.
 */
export function SncrNoBalanceCard() {
  const {
    isAuthenticated,
    authChecked,
    authRequired,
    feedback,
    requestNumbering,
    confirmAuth,
    dismissAuth,
    dismissFeedback,
    retry,
  } = useSncrRequestShortcut();

  const description = isAuthenticated
    ? 'Ao solicitar a numeração, faremos a requisição para todos os tipos de receita disponíveis'
    : 'Verifique suas permissões de prescrição e faça a solicitação';

  return (
    <>
      <Flex
        bg={SNCR_COLORS.alertBackground}
        borderRadius="8px"
        padding="12px 16px"
        borderColor={SNCR_COLORS.alertBorder}
        borderWidth={'1px'}
        gap="12px"
        alignItems={{ base: 'flex-start', md: 'center' }}
        justifyContent="space-between"
        flexDir={{ base: 'column', md: 'row' }}
      >
        <Flex gap={'10px'} alignItems={'center'}>
          <Alert />
          <Box display={'flex'} flexDirection={'column'} gap={'8px'}>
            <Text fontSize="16px" fontWeight={700} fontFamily={FONT_ONEST} color={SNCR_COLORS.balanceOk}>
              Sem saldo de numerações SNCR para esse tipo de receita
            </Text>
            <Text fontSize="14px" fontWeight={600} fontFamily={FONT_ONEST} color={SNCR_COLORS.textPrimary}>
              {description}
            </Text>
          </Box>
        </Flex>
        <Button
          borderRadius={'20px'}
          display={'flex'}
          justifyContent={'center'}
          fontWeight={700}
          fontSize={'14px'}
          gap="10px"
          rightIcon={<ChevronRightIcon />}
          onClick={requestNumbering}
          isLoading={!authChecked}
          pointerEvents={'auto'}
        >
          Solicitar numeração
        </Button>
      </Flex>

      {authRequired && <SncrAuthRequiredModal onAuthenticate={confirmAuth} onDismiss={dismissAuth} />}
      {feedback && feedback.kind !== 'error' && <SncrFeedbackModal feedback={feedback} onDismiss={dismissFeedback} />}
      {feedback?.kind === 'error' && (
        <SncrErrorModal code={feedback.code} onDismiss={dismissFeedback} onRetry={retry} />
      )}
    </>
  );
}
